<template>
	<section class="footer-block">
		<ul class="footer-menus">
			<li class="footer-menu-item goodsSearch" :class="{'active':$store.state.pageBelong=='GoodsSearch'}" @click="pageChange('/SearchIndex')">产品查询</li>
			<li class="footer-menu-item shopBag" id="shopCart" :class="{'active':$store.state.pageBelong=='ShopBag'}" @click="pageChange('/ShopBag')">购物车<i class="goods-num" v-if="$store.state.shopCount">{{$store.state.shopCount}}</i> </li>
			<li class="footer-menu-item orderList" :class="{'active':$store.state.pageBelong=='OrderList'}" @click="pageChange('/OrderList')">订单</li>
			<li class="footer-menu-item userCenter" :class="{'active':$store.state.pageBelong=='UserCenter'}" @click="pageChange('/UserCenter')">个人中心</li>
		</ul>
	</section>
</template>

<script>
	export default {
		name: 'footer',
		data() {
			return {
			}
		},
		beforeRouteEnter: function(to, from, next) {
			console.log($1111)
			//to.meta.keepAlive = true;  //
			next();
		},
		methods:{
			pageChange(path){
				this.$router.push({path:path});
			}
		},
		components: {}
	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" type="text/scss" rel="stylesheet/scss">
.footer-block{
	position: fixed;
    bottom:0;
    left:0;
    width: 100%;
    background-color: #fff;
    .footer-menus{
    	display: flex;
    	border-top: 1px solid #eee;
    	.footer-menu-item{
    		position: relative;
		    flex: 1;
		    padding-top: .25rem;
		    text-align: center;
		    font-size: .12rem;
		    line-height: .2rem;
		    color: #666;
		    background-repeat: no-repeat;
		    background-position: center .05rem;
		    background-size: .22rem;
		    &.active{
		    	color:$mainColor;
		    	&.goodsSearch{
				    background-image: url(../../assets/footer-icon-search-r.png);
				}
				&.shopBag{
				    background-image: url(../../assets/footer-icon-shopping-r.png);
				}
				&.orderList{
				    background-image: url(../../assets/footer-icon-order-r.png);
				}
				&.userCenter{
				    background-image: url(../../assets/footer-icon-user-r.png);
				}
		    }
		    &:active{
		    	background-color: rgba(245, 23, 40, 0.11);
		    }
		    &.goodsSearch{
			    background-image: url(../../assets/footer-icon-search-g.png);
			}
			&.shopBag{
			    background-image: url(../../assets/footer-icon-shopping-g.png);
			}
			&.orderList{
			    background-image: url(../../assets/footer-icon-order-g.png);
			}
			&.userCenter{
			    background-image: url(../../assets/footer-icon-user-g.png);
			}
			.goods-num{
			    position: absolute;
			    top: .02rem;
			    left: 60%;
			    width: .21rem;
			    height:.21rem;
			    line-height: .21rem;
			    font-size: .12rem;
			    color: #fff;
			    text-align: center;
			    border-radius: .2rem;
			    background-color: $mainColor;
			}
    	}
    }
}
</style>



// WEBPACK FOOTER //
// src/basic/layout/footerBar.vue